<template>
    <svg
        class="sparkle_svg"
        :style="{ position: 'absolute', width: size + 'px', height: size + 'px', zIndex: 2 }"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 44"
        :fill="fillColor"
    >
        <path
          :fill="fillColor"
          d="M35.9766 31.4141C35.6641 31.2188 31.1719 27.7422 25.7812 23.1719C27.2656 26.6094 28.2813 29.3437 28.4375 29.6953C28.2813 29.3828 27.0703 27.1172 25.6641 24.0312C25.5859 34.9297 25 43.4844 25 43.4844C25 43.4844 24.4141 34.8125 24.3359 23.7969C22.6562 27 21.2891 29.3828 21.2109 29.5781C21.2891 29.3828 22.4219 26.7266 24.1016 23.25C18.75 27.8203 14.3359 31.2188 14.0234 31.4141C14.2969 31.1797 18.2812 27.3125 23.6328 22.6641C19.6094 23.9531 16.4453 24.8125 16.0547 24.9297C16.4062 24.7734 19.0625 23.7578 22.6562 22.5469C9.96094 22.5078 0 22 0 22C0 22 10.0781 21.4922 22.8906 21.4531C19.1406 20.0078 16.4062 18.8359 16.2109 18.7578C16.4062 18.7969 19.5312 19.7734 23.5547 21.2188C18.2422 16.6094 14.2969 12.8203 14.0234 12.5859C14.2969 12.8203 18.7891 16.2578 24.2188 20.8672C22.7344 17.4297 21.6797 14.6953 21.5625 14.3438C21.7188 14.6563 22.9297 16.9219 24.3359 20.0078C24.4141 9.07031 25 0.515625 25 0.515625C25 0.515625 25.5859 9.1875 25.6641 20.2031C27.3437 17 28.7109 14.6172 28.7891 14.4609C28.7109 14.6562 27.5781 17.3125 25.8984 20.7891C31.25 16.2188 35.6641 12.8203 35.9766 12.625C35.7031 12.8594 31.7188 16.7266 26.3672 21.375C30.3906 20.0859 33.5547 19.2266 33.9453 19.1094C33.5938 19.2656 30.9375 20.2812 27.3828 21.4922C40.0781 21.5703 50.0391 22.0391 50.0391 22.0391C50.0391 22.0391 39.9609 22.5469 27.1484 22.5859C30.8984 24.0312 33.6328 25.2031 33.8281 25.2812C33.5938 25.2031 30.4688 24.2266 26.4844 22.7812C31.7578 27.3906 35.7031 31.1797 35.9766 31.4141Z"
        />
    </svg>
</template>

<script setup lang="ts">
    import { ref, onMounted, onBeforeUnmount } from 'vue';

    interface SparkleOptions {
        fill?: string;
        stroke?: string;
        size?: number;
        delay?: number;
        duration?: number;
        pause?: number;
        title: string; // Added title prop for the h2 text
    }

    const props = defineProps<SparkleOptions>();

    const fillColor = props.fill || "#fff";
    const strokeColor = props.stroke || "#000";
    const size = props.size || 20;
    const duration = props.duration || 1500;
    const pause = props.pause || 1000;
    const delay = props.delay || 0;
    const title = props.title; // Extracting title prop
    let intervalId: ReturnType<typeof setInterval> | null = null;

    const getCoordinates = () => {
        return {
            left: Math.random() * 180,
            top: (Math.random() - 0.8) * 30
        };
    };

    const applyRandomPosition = (selector: string) => {
        const svgElement = document.querySelector(selector) as SVGElement | null;
        const coords = getCoordinates();
        if (svgElement) {
            svgElement.style.left = `${coords.left}px`;
            svgElement.style.top = `${coords.top}px`;
            svgElement.style.position = 'absolute';
            svgElement.style.animation = `my-sparkle ${props.duration}ms infinite linear`;
            svgElement.style.display = 'block';
        }
    };
    onMounted(() => {
        applyRandomPosition('.sparkle_svg:nth-of-type(1)');
        applyRandomPosition('.sparkle_svg:nth-of-type(2)');
        intervalId = setInterval(() => {
            applyRandomPosition('.sparkle_svg:nth-of-type(1)');
            applyRandomPosition('.sparkle_svg:nth-of-type(2)');
        }, 3000);
    });
    onBeforeUnmount(() => {
        if (intervalId) {
            clearInterval(intervalId);
        }
    });
</script>

